<template>
  <div>
    <fragment v-if="form">
      <EndorsementForm
        :form="form"
        @submit="submitNewEndorsement"
        name-button="CRIAR"
        @cancel="previousPageEndorsement"
        is-create
      />
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPageEndorsement"
      title="ENDOSSO CRIADO"
      text="Novo endosso foi criado com sucesso."
    />
    <ModalCancelEndoserment
      @close="closeModalCancel"
      v-model="modalCancelEndoserment"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </div>
</template>
<script>
import EndorsementForm from "../../policy/components/EndorsementForm";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelEndoserment from "../../insurance_company/components/ModalCancelInsurance";
import RequestEndorsementMixin from "@/mixins/RequestEndorsementMixin";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
export default {
  mixins: [RequestEndorsementMixin],
  data: () => ({
    form: null,
    modal: false,
    cloneForm: {},
    formatDateToDDMMYYYY
  }),
  components: {
    EndorsementForm,
    ModalGenericCriticism,
    ModalCancelEndoserment
  },
  methods: {
    previousPageEndorsement() {
      this.modal = false;
      this.$router.push({
        name: "list request endorsement"
      });
    }
  }
};
</script>
